import React, { useState } from 'react';
import Modal from "react-modal";
import { enterpriseMenu } from '../../common';
import { pushLocation } from '../../../utilities/customRoutes';

function AcceptModal(props) {
    const { model } = props;
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [isInstanceReady, setIsInstanceReady] = useState(false)

    const closeModal = () => { setIsModalOpen(false) }

    const renderIframeModal = () => {
        return (
            <Modal
                isOpen={isModalOpen ? true : false}
                onRequestClose={closeModal}
                overlayClassName="bb-modal-overlay"
                className="bb-modal-container mx-400"
                bodyOpenClassName="overflow-hidden"
                ariaHideApp={false}
            >
                <div className='col-sm-12 col-md-12 d-flex py-5 flex-column justify-content-center text-center h-300'>
                    {/* <img className="mx-300 m-auto pb-4" src={`${getEnterpriseLogo()}`} alt='' /> */}

                    {!isInstanceReady ? <>
                        <h5 className='mb-4'>Your <strong>{model === 1 ? "" : model === 2 ? "Volume Rewards" : "Volume Discount"}</strong> account is being created. </h5>
                        <small className='mb-4'>Please wait......</small>
                        <div className="d-flex align-self-center justify-content-center bb-spinner-container"
                            style={{ height: '50px', width: '50px' }}
                        >
                            <span><img src='/images/icons/loading.svg' style={{ height: '50px', width: '50px' }} alt="" /></span>
                        </div>
                    </> : <>
                        <h5>Your <strong>{model === 1 ? "" : model === 2 ? "Volume Rewards" : "Volume Discount"}</strong> account is ready to start using.</h5>

                        <button type="button" style={{position: "absolute", bottom: "19px"}}onClick={() => {
                            if (model === 1) {
                                pushLocation("/fees")
                            } else if (model === 2){
                                pushLocation("/earnings")
                            }
                            else{
                                pushLocation("/savings")
                            }
                        }} className="bb-button align-self-center" disabled={false}>Ok</button>
                    </>}



                </div>
            </Modal>)
    }
    
    return (
        <>
            {isModalOpen ? renderIframeModal() : null}
            <button type="button" className="bb-button mr-3 w-100" disabled={false} onClick={() => {

                setIsModalOpen(true)
                setTimeout(() => {
                    setIsInstanceReady(true)
                    //setTimeout(()=>{
                    localStorage.setItem("enterprise", "selected")
                    enterpriseMenu(model)

                    //}, 2000)

                }, 3000);
            }}>Done</button>
        </>

    );
}
export default AcceptModal;